import React from 'react'

function SongSlider() {

  function setLocation(percentage) {
    let activeSong = document.getElementById(`player-source`)
    activeSong.currentTime = activeSong.duration * percentage
  }
  
  function setSongPosition(pos) {
    let sliderWidth = document.getElementById(`song-slider`).offsetWidth,
        sliderOffset = document.getElementById(`song-slider`).offsetLeft,
        sliderClickedPos = (pos.clientX - sliderOffset),
        percentage = (sliderClickedPos / sliderWidth)
    
    setLocation(percentage)
  }
  
  return (
    <div id={`song-slider`} onClick={(pos) => setSongPosition(pos)}><div id={`track-progress`}></div></div>
  )
}

export default SongSlider